import type { SlideProps } from "@/engine/app/offsite-config";

const TILES = [
  {
    eyebrow: "Zendesk Telefonie",
    title: "Bevor ihr abhebt: wer anruft + was er vermutlich will.",
    text: "Kundendaten in Zendesk – sofort griffbereit.",
  },
  {
    eyebrow: "Eingehender Anruf",
    title: "[Kunde] · Vermutliches Anliegen",
    text: "Zendesk-Kontext: [Letzte Interaktion · Vertrag · Zähler]",
  },
];

export function Slide10TelefonKontext(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">KI im Kundenservice</div>
        <h1 className="deck-title rise rise-2">
          Telefon mit <br />
          <span className="accent">Kontext</span>
        </h1>
        <p className="deck-sub rise rise-3">Zendesk Telefonie mit Kundenkontext.</p>
      </header>

      <div className="telefon-body">
        <div className="ki-sort-quote rise rise-4">
          <div className="ki-sort-quote-from">Eingehender Anruf · Petra Wattmann</div>
          <div className="ki-sort-quote-text">
            Hat vor 2 Tagen eine komplexe Tarifumstellung angefragt – per Auto-Reply die Antwort
            „<em>wir melden uns</em>" erhalten. Ruft jetzt vermutlich genau deswegen an.
          </div>
          <div className="ki-sort-quote-tags">
            <span className="ki-sort-tag">Ticket #4711 offen</span>
            <span className="ki-sort-tag">Tarifumstellung</span>
            <span className="ki-sort-tag">Wartet auf Rückmeldung</span>
          </div>
        </div>

        <div className="deck-cols2">
          {TILES.map((t, i) => (
            <div key={t.title} className={`col-card rise rise-${i + 5}`}>
              <div className="col-eyebrow">{t.eyebrow}</div>
              <h4>{t.title}</h4>
              <p>{t.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
